var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "cog-section cog-repeating-section",
      class: [
        "cog-col",
        _vm.colNumClass,
        {
          "is-error": _vm.showError,
          "cog-section--heading": _vm.$source.label && !_vm.hideLabel,
          "is-read-only": _vm.$source.readonly,
          ["cog-field--" + _vm.fieldIndex]: _vm.fieldIndex,
          "cog-force-shown": _vm.forceShown,
          "show-remove-button": _vm.showRemoveButton,
          "hide-remove-button": !_vm.showRemoveButton
        }
      ],
      attrs: {
        "aria-labelledby": "cog-" + _vm.$source.id,
        tabindex: _vm.showValidation ? 0 : -1,
        "aria-describedby": _vm.showError
          ? `cog-${_vm.$source.id}-error`
          : undefined,
        "aria-invalid": _vm.showError ? true : undefined
      },
      on: { click: _vm.triggerErrors, keyup: _vm.triggerErrors }
    },
    [
      _c(
        "div",
        { staticClass: "cog-section__inner" },
        [
          _vm._t("header", function() {
            return [
              _vm.showLabel
                ? _c(
                    "h" + Math.min(_vm.depth + 1, 4),
                    {
                      tag: "h2",
                      staticClass: "cog-section__heading cog-heading",
                      attrs: { id: "cog-" + _vm.$source.id }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$source.label) + "\n\t\t\t\t"
                      ),
                      _vm.showError
                        ? _c("span", { staticClass: "cog-offscreen" }, [
                            _vm._v(", " + _vm._s(_vm.errorMessage))
                          ])
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$source.helptext && !_vm.$source.readonly
                ? _c("div", {
                    staticClass: "cog-helptext cog-html",
                    domProps: { innerHTML: _vm._s(_vm.$source.helptext) }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c(
            "list-transition",
            { attrs: { scroll: _vm.allowScroll && _vm.flags.autoScroll } },
            _vm._l(_vm.$source.items, function($item, index) {
              return _c(
                "c-row",
                { key: $item.value.meta.id },
                [
                  _c(
                    "c-section",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !$item.isHidden,
                          expression: "!$item.isHidden"
                        }
                      ],
                      ref: "repeatingSection",
                      refInFor: true,
                      staticClass: "cog-repeating-section__section",
                      class: {
                        "cog-section--heading": _vm.itemLabel,
                        "is-read-only": _vm.$source.readonly,
                        [`${$item.class}`]: $item.class
                      },
                      attrs: {
                        "aria-labelledby": `cog-${_vm.$source.id}-${index}`,
                        background: index % 2 ? "alternate" : "main",
                        source: $item
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function() {
                              return [
                                _c(
                                  "h" + Math.min(_vm.depth + 2, 4),
                                  {
                                    tag: "h3",
                                    staticClass:
                                      "cog-repeating-section__heading cog-heading",
                                    attrs: {
                                      id: `cog-${_vm.$source.id}-${index}`
                                    }
                                  },
                                  [
                                    _c(
                                      "transition",
                                      {
                                        attrs: { appear: "", name: "cog-fade" }
                                      },
                                      [
                                        _vm.showRemoveButton
                                          ? _c(
                                              "c-button",
                                              {
                                                staticClass:
                                                  "cog-repeating-section__remove-button",
                                                attrs: {
                                                  "no-style": "",
                                                  title: _vm.getRemoveButtonText(
                                                    _vm.itemLabel,
                                                    $item.value.ItemNumber
                                                  )
                                                },
                                                on: {
                                                  click: e =>
                                                    _vm.removeItem(e, index)
                                                }
                                              },
                                              [_c("i-ex")],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm._t(
                                      "readonly-item-header",
                                      function() {
                                        return [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.itemLabel) +
                                              " " +
                                              _vm._s($item.value.ItemNumber) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      },
                                      { item: $item.value }
                                    )
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm._t("default", null, {
                        item: $item.value,
                        adapter: $item,
                        cols: _vm.cols
                      })
                    ],
                    2
                  )
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm._t("footer"),
          _vm._v(" "),
          _c(
            "visible-transition",
            [
              _vm.showAddButton
                ? _c(
                    "c-button",
                    {
                      staticClass:
                        "cog-button--secondary cog-repeating-section__add-button",
                      class: {
                        "cog-button--no-text":
                          _vm.getAddButtonText(_vm.itemLabel) === ""
                      },
                      attrs: {
                        title:
                          _vm.getAddButtonText(_vm.itemLabel) === ""
                            ? _vm.getGeneratedAddButtonText(_vm.itemLabel)
                            : null
                      },
                      on: { click: _vm.addItem },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "icon",
                            fn: function() {
                              return [_c("i-plus")]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        4092991805
                      )
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.getAddButtonText(_vm.itemLabel)) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "cog-error-message" } }, [
        _vm.showError
          ? _c(
              "div",
              {
                staticClass:
                  "cog-error-message cog-error-message--container-footer",
                attrs: {
                  id: `cog-${_vm.$source.id}-error`,
                  "aria-live": _vm.showLabel ? null : "polite",
                  role: "alert"
                }
              },
              [_vm._v(_vm._s(_vm.errorMessage))]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }